<template>
	<section class="Table">
		<!-- <div class="wrapper"> -->
		<v-card class="my-5 pb-3 px-4">
			<v-card-title class="gap-20 justify-space-between px-0">
				<div class="Table_control">
					<div class="d-flex align-items-end">
						<input
							class="flex-grow-1"
							v-model="searchBarValue"
							placeholder="Search"
							maxlength="20"
						/>
						<select class="flex-grow-0" v-model="filterStatus">
							<option value="">All Status</option>
							<option
								v-for="option in statusOptions"
								:value="option"
							>
								{{ option }}
							</option>
						</select>
						<select class="flex-grow-0 ml-2" v-model="itemsPerPage">
							<option
								v-for="option in itemsPerPageOptions"
								:value="option"
							>
								Show {{ option }} entries
							</option>
						</select>
					</div>
				</div>
			</v-card-title>

			<v-data-table
				:headers="headers"
				:items="leads"
				:search="searchBarValue"
				:items-per-page="itemsPerPage"
				:single-expand="true"
				:expanded.sync="itemExpanded"
				:footer-props="{ 'disable-items-per-page': true }"
				:custom-sort="customSort"
				item-key="id"
				fixed-header
			>
				<!-- hide-default-footer -->
				<!-- @item-expanded="onExpand" -->
				<!-- @click:row="(item, slot) => slot.expand(!slot.isExpanded)" -->

				<template v-slot:loading>
					<div class="text-center">
						<!-- <v-progress-circular indeterminate color="gray"></v-progress-circular> -->
						Loading leads... Please wait
					</div>
				</template>

				<template v-slot:header.status="{ header: th }">
					<StatusTooltip />
					<span>{{ th.text }}</span>
				</template>

				<template v-slot:item="{ item, expand, isExpanded }">
					<TableRow
						:editable="editable"
						:propertyType="parseInt(propertyType)"
						:item="item"
						:key="item.id"
						:expand="expand"
						:isExpanded="isExpanded"
					/>
				</template>

				<template v-slot:expanded-item="{ item, headers }">
					<TableExpand
						:editable="editable"
						:item="item"
						:headers="headers"
					/>
				</template>
			</v-data-table>
		</v-card>
		<!-- </div> -->
	</section>
</template>

<script>
import TableRow from "@/components/TableMeetings/TableRow";
import TableExpand from "@/components/TableMeetings/TableExpand";
import { leadsTablesStatusSort } from "@/utilities";
import StatusTooltip from "@/components/StatusTooltip";
import { LEAD_STATUSES } from "@/constants";

export default {
	name: "TableMeetings",
	components: {
		TableRow,
		TableExpand,
		StatusTooltip,
	},
	props: {
		leads: {
			type: Array,
			default: () => [],
		},
		editable: {
			type: Boolean,
			default: true,
		},
		propertyType: {
			type: Number | String,
			default: null,
		},
	},
	data() {
		return {
			search: "",
			itemsPerPage: 10,
			itemsPerPageOptions: [10, 50, 100],
			itemExpanded: [],
			headers: [
				{ value: "name", text: "Full Name" },
				{ value: "company", text: "Company" },
				{ value: "date", text: "Date Received" },
				{ value: "status", text: "Status", filter: this.filterByStatus },
				{ value: "revenue", text: "Revenue", sortable: false },
				{ value: "calculate", text: "Calculate", sortable: false },
			],
			statusOptions: LEAD_STATUSES,
			filterStatus: "",
		};
	},
	computed: {
		searchBarValue:{
			get(){
				return this.$store.state.leads.searchValue;
			},
			set( newValue ){
				this.$store.commit('setNewSearch', newValue);
			}
		}
	},
	methods: {
		// onExpand (obj) {
		//   console.log(this.itemExpanded, obj);
		// },
		customSort: leadsTablesStatusSort,
		filterByStatus (v) {
			if (!this.filterStatus) return true;
			return v === this.filterStatus;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.Table {
	display: block;
	&_title {
		font-size: 27px !important;
		color: $purple;
	}
	&_control {
		width: 50%;
		padding: 5px 20px;
		border: 1px solid #e2e2e2;
		border-radius: 5px;
		@media screen and (max-width: 960px) {
			width: auto;
		}
		input,
		select {
			font-weight: 400;
			display: block;
			padding: 0 15px;
			appearance: none;
			&:focus {
				outline: 0;
			}
		}
		input {
			font-size: 13px;
			background: url("../assets/img/icon-search1.svg") no-repeat left
				center;
			padding-left: 30px;
		}
		select {
			font-size: 12px;
			background: url("../assets/img/arrow-select1.svg") no-repeat right 5px
				center;
			width: 150px;
			border-left: 1px solid #e2e2e2;
			cursor: pointer;
		}
	}
	&_exportBtn {
		cursor: pointer;
	}
	/deep/ .v-data-table-header {
		th {
			background: darken($purple, 12%) !important;
			white-space: nowrap;
			&:first-child {
				border-top-left-radius: 5px;
			}
			&:last-child {
				border-top-right-radius: 5px;
				&[aria-label="Calculate"] {
					background: $purple !important;
					text-align: center !important;
				}
			}
			span {
				color: #fff;
			}
			.custom-icon {
				display: inline-block;
				vertical-align: middle;
				margin-right: 0.5em;
				img {
					display: block;
				}
			}
			.v-icon {
				background: url("../assets/img/icon-sort1.svg") no-repeat center
					center;
				display: inline-block;
				width: 0.7em;
				height: 0.7em;
				margin-left: 0.7em;
				opacity: 0.4;
				&::after {
					display: none;
				}
			}
			&.active {
				.v-icon {
					opacity: 1;
				}
			}
		}
	}

	/deep/ .v-data-footer {
		justify-content: flex-end;
		padding-top: 10px;
		border-top: 0;
		&__select {
			display: none;
		}
		.v-icon {
			&.mdi-chevron-left {
				background: url("../assets/img/arrow-left2.svg") no-repeat
					center center;
				margin-right: 3px;
			}
			&.mdi-chevron-right {
				background: url("../assets/img/arrow-right2.svg") no-repeat
					center center;
				margin-left: 3px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/TableMeetings.vue